/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProfilingWizardChecklistItemId } from './ProfilingWizardChecklistItemId';
import {
    ProfilingWizardChecklistItemIdFromJSON,
    ProfilingWizardChecklistItemIdFromJSONTyped,
    ProfilingWizardChecklistItemIdToJSON,
    ProfilingWizardChecklistItemIdToJSONTyped,
} from './ProfilingWizardChecklistItemId';

/**
 * One condition of the checklist. The label of the item is chosen by the frontend from its id.
 * @export
 * @interface ProfilingWizardChecklistItem
 */
export interface ProfilingWizardChecklistItem {
    /**
     * 
     * @type {ProfilingWizardChecklistItemId}
     * @memberof ProfilingWizardChecklistItem
     */
    id: ProfilingWizardChecklistItemId;
    /**
     * Indicates whether the condition is fulfilled.
     * @type {boolean}
     * @memberof ProfilingWizardChecklistItem
     */
    completed: boolean;
}



/**
 * Check if a given object implements the ProfilingWizardChecklistItem interface.
 */
export function instanceOfProfilingWizardChecklistItem(value: object): value is ProfilingWizardChecklistItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('completed' in value) || value['completed'] === undefined) return false;
    return true;
}

export function ProfilingWizardChecklistItemFromJSON(json: any): ProfilingWizardChecklistItem {
    return ProfilingWizardChecklistItemFromJSONTyped(json, false);
}

export function ProfilingWizardChecklistItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilingWizardChecklistItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ProfilingWizardChecklistItemIdFromJSON(json['id']),
        'completed': json['completed'],
    };
}

export function ProfilingWizardChecklistItemToJSON(json: any): ProfilingWizardChecklistItem {
    return ProfilingWizardChecklistItemToJSONTyped(json, false);
}

export function ProfilingWizardChecklistItemToJSONTyped(value?: ProfilingWizardChecklistItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ProfilingWizardChecklistItemIdToJSON(value['id']),
        'completed': value['completed'],
    };
}

